import { ActionTypes } from './types';
import { Action } from '../../../types';

const setAccountType = (accountType: string): Action<ActionTypes, string> => ({
  type: ActionTypes.SET_ACCOUNT_TYPE,
  payload: accountType,
});

export default setAccountType;
